module.exports = __webpack_public_path__ + "img/selected5-min.3862d383.png";